export function accept_agbs() {
    console.log("[accept_agbs] running");
    
    $(document).ready(function () {
        $('.navbar-clickable-link').attr('href', '');
        console.log('test');
    });
}